// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3MIRO","content":"Consent_content__2xa5C","footer":"Consent_footer__1ZL0H"};